import http from '../../core/services/http'

export const generateChangedMenuUrlsReport = () =>
  http.get('/reports/changed-menu-urls', { responseType: 'blob' })
